export * from '@primeuix/themes/aura/tooltip';
export { default } from '@primeuix/themes/aura/tooltip';
